import 'babel-polyfill';
import 'whatwg-fetch';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider, connect } from 'react-redux';
import { Bridge } from '@nackle/bridge';

import AppStore from './app-store';

import auth, { authRouteMiddleware, authRequestMiddleware } from './app-auth';
// Routing
import { Route, routeHistory } from '@nackle/biw-web-router';
import { routes, getMiddleware as getRouteMiddleware } from './app-routing.jsx';

import Deck from './components/shared/deck';
import LoadingOverlay from './components/shared/loader/loading-overlay.jsx';
import createNewRelic from './create-new-relic.js';
import { DEFAULT_GOLD_COMPANY_ID } from './utils/constants';
import { Position, Toaster } from '@blueprintjs/core';
import { clearToast } from './dux/app';

import './assets/styles/app.scss';
import { applyRequestMiddleware } from './utils/fetch';

const AppToaster = Toaster.create( {
    className: 'app-toaster',
    position: Position.TOP
} );

class UserHeader extends React.Component {
    render() {
        return (
            <div className="user-header">
                <div className="container">
                    <div className="user-info">
                        <span> { this.props.user } </span>
                        <a href="#sign-out" role="button" onClick={ auth.signOut }>
                            Sign Out
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

class AdminHeader extends React.Component {
    render() {
        return (
            <div className="admin-header">
                <div className="container">
                    <span className="header-logo">
                        <img 
                            src="https://s3-us-west-2.amazonaws.com/images.biw.cloud--prod/c3d5883b-8e2a-4a7b-97bd-62fe75bdb8ab"
                            alt="BI Worldwide logo" />
                    </span>
                    <h1 className="header"> Email Builder </h1>
                    <div className="link-container" >
                        <button className="home" onClick={ this.handleHomeClick }>Home</button>
                        <span className="divider">|</span>
                        <button className="new-email" onClick={ this.handleNewEmailClick }>New Email</button>
                    </div>
                </div>
            </div>
        );
    }

    handleHomeClick = () => {
        routeHistory.push( '/' );
    };

    handleNewEmailClick = () => {
        routeHistory.push( '/email' );
    };
}

class App extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            user: ''
        };
    }

    getUser = async ( user ) => {
        await auth.delegate( DEFAULT_GOLD_COMPANY_ID );

        this.setState( {
            user: user.claims
        } );
    };

    // handleSignIn = async ( user ) => {
    //     const match = window.location.pathname.match(
    //         /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
    //     );
    //     if ( match?.[ 0 ] ) {
    //         await auth.delegate( match[ 0 ] );
    //     } else {
    //         await auth.delegate( DEFAULT_GOLD_COMPANY_ID );
    //     }

    //     if ( user.claims ) {
    //         this.setState( {
    //             user: user,
    //             locale: user.claims.locale
    //         } );
    //         routeHistory.refresh();

    //         this.setState( { bundlesLoaded: true } );
    //     }
    // };

    componentDidMount() {
        if ( location.hostname !== 'localhost' ) {
            createNewRelic(BIW_ENVIRONMENT); //eslint-disable-line
        }
    }

    componentDidUpdate( prevProps, prevState ) {
        if ( this.props.toasts.length > 0 ) {
            this.props.toasts.forEach( toast => {
                AppToaster.show( { ...toast } );
            } );
            this.props.clearToast();
        }
    }

    render() {
        const {
            loading,
            primaryLogo = ''
        } = this.props;

        const {
            user
        } = this.state;

        return (
            <Route render={ ( route ) => {
                return (
                    <Bridge auth={ auth } onSignIn={ this.getUser }>
                        <div className="app-container">
                            {
                                route.match ?
                                    <div>
                                        <LoadingOverlay loading={ loading } />
                                        <Deck>
                                            { user.name &&
                                                <React.Fragment>
                                                   <UserHeader user={ user.name }/>
                                                   <AdminHeader logo={ primaryLogo }/>
                                                </React.Fragment>
                                            }
                                        </Deck>
                                        <div className="container">
                                            { user && route.component }
                                        </div>
                                    </div>
                                    :
                                route.pathname && <h1> Page Not Found </h1>
                            }
                        </div>
                    </Bridge>
                );
            } }/>
        );
    }

}

App = connect(
    state => ( {
        loading: state.app.loading,
        loadingError: state.app.loadingError,
        toasts: state.app.toasts
    } ),
    {
        clearToast
    }
)( App );


// add extra middleware for modern auth
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware ] );
routeHistory.applyMiddleware( getRouteMiddleware( AppStore ) );

applyRequestMiddleware( authRequestMiddleware );

const root = createRoot( document.getElementById( 'app-root' ) );

root.render(
    <Provider store={ AppStore() }>
        <App />
    </Provider>
);